// Keine offenen Stellen. Neue Stellen nur mit echtem PDF eintragen.
export const vacancies = [];
